import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileMb',
    standalone: false
})
export class FileMbPipe implements PipeTransform {

  transform<T>(value: T): T {
    if (!value)  {
      return null;
    }

    return ((value as number) / (1024 * 1024)).toFixed(2) as T;
  }

}
